import { render, staticRenderFns } from "./FlightCarbonEmissionsBadge.vue?vue&type=template&id=fa7a467c&scoped=true&"
import script from "./FlightCarbonEmissionsBadge.vue?vue&type=script&lang=js&"
export * from "./FlightCarbonEmissionsBadge.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fa7a467c",
  null
  
)

export default component.exports